import React from "react";
import { LogOut } from 'lucide-react';
// import { useNavigate } from "react-router-dom";

const AdminHeader = () => {

  // const navigate = useNavigate();

  // fetching data for name
  const adminname = localStorage.getItem("adminname");
  const firstLetter = adminname.charAt(0).toUpperCase();

  const handlelogin = () => {
window.location.replace("/login");
localStorage.removeItem("admintoken");
  };

  const styles = {
    container: {
      position:"sticky",
  width:"100%",
    // width:"calc(100% - 300px)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "20px",
      // marginBottom:"20px",
     top: "0",
  zIndex: "100",
  background: "white"
    },
    right: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
    },
    avatar: {
  width:"40px",
  height:"40px",
  borderRadius:"50%",
  background:"#000",
  color:"#fff",
  display:"flex",
  alignItems:"center",
  justifyContent:"center",
  fontsize:"18px",
  fontWeight:"600"
}
};

  return (
    <div style={styles.container}>
      <strong>Hello ,  {adminname}</strong>

      <div style={styles.right}>
        <span onClick={handlelogin}><LogOut/></span>
        <div style={styles.avatar}>{firstLetter}</div>
      </div>

    </div>
  );
};

export default AdminHeader;